module.exports = __webpack_public_path__ + "static/media/sony-alpha-3.492b3069.jpg";